import { call, put, takeEvery } from 'redux-saga/effects'
import * as nhanSuActions from '@redux/ducks/nhanSu.Ducks'
import * as hoSoApi from '@apis/nhanSu/hoSo.Api'
import * as giaDinhApi from '@apis/nhanSu/giaDinh.Api'
import * as taiLieuApi from '@apis/nhanSu/taiLieu.Api'
import * as hopDongApi from '@apis/nhanSu/hopDong.Api'
import * as khenThuongKyLuatApi from '@apis/nhanSu/khenThuongKyLuat.Api'
import * as baoHiemApi from '@apis/nhanSu/baoHiem.Api'
import * as duLieuThamChieuApi from '@apis/nhanSu/duLieuThamChieu.Api'

function* fetchDanhSachHoSo({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof hoSoApi.locHoSo> = yield call(hoSoApi.locHoSo, queryStr ? JSON.parse(queryStr) : undefined)
    yield put(nhanSuActions.layDanhSachHoSoThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachHoSoThatBai(error))
  }
}

function* fetchDanhSachGiaDinh({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof giaDinhApi.locGiaDinh> = yield call(giaDinhApi.locGiaDinh, queryStr ? JSON.parse(queryStr) : undefined)
    yield put(nhanSuActions.layDanhSachGiaDinhThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachGiaDinhThatBai(error))
  }
}

function* fetchDanhSachTaiLieu({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof taiLieuApi.locTaiLieu> = yield call(taiLieuApi.locTaiLieu, queryStr ? JSON.parse(queryStr) : undefined)
    yield put(nhanSuActions.layDanhSachTaiLieuThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachTaiLieuThatBai(error))
  }
}

function* fetchDanhSachHopDong({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof hopDongApi.locHopDong> = yield call(hopDongApi.locHopDong, queryStr ? JSON.parse(queryStr) : undefined)
    yield put(nhanSuActions.layDanhSachHopDongThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachHopDongThatBai(error))
  }
}

// Khen thưởng & Kỷ luật
function* fetchDanhSachKhenThuongKyLuat({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof khenThuongKyLuatApi.locKhenThuong> = yield call(khenThuongKyLuatApi.locKhenThuong, queryStr ? JSON.parse(queryStr) : undefined)
    yield put(nhanSuActions.layDanhSachKhenThuongKyLuatThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachKhenThuongKyLuatThatBai(error))
  }
}

function* fetchDanhSachBaoHiem({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof baoHiemApi.locDongBaoHiem> = yield call(baoHiemApi.locDongBaoHiem, queryStr ? JSON.parse(queryStr) : undefined)
    yield put(nhanSuActions.layDanhSachBaoHiemThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachBaoHiemThatBai(error))
  }
}

function* fetchDanhSachDuLieuThamChieu({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof duLieuThamChieuApi.layDanhSachPhongBan> = yield call(duLieuThamChieuApi.layDanhSachPhongBan, params.chinhanhId)
    yield put(nhanSuActions.layDanhSachDuLieuThamChieuThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachDuLieuThamChieuThatBai(error))
  }
}

function* fetchDanhSachThongTinKhac({ payload: queryStr }: { type: string; payload: any }): Generator<any, void, any> {
  try {
    void queryStr
    const res: any = yield call(() => Promise.resolve({ data: [] }))
    yield put(nhanSuActions.layDanhSachThongTinKhacThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachThongTinKhacThatBai(error))
  }
}

function* fetchDanhSachThaoTacHangLoat({ payload: queryStr }: { type: string; payload: any }): Generator<any, void, any> {
  try {
    void queryStr
    const res: any = yield call(() => Promise.resolve({ data: [] }))
    yield put(nhanSuActions.layDanhSachThaoTacHangLoatThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachThaoTacHangLoatThatBai(error))
  }
}

function* fetchDanhSachXuatNhap({ payload: queryStr }: { type: string; payload: any }): Generator<any, void, any> {
  try {
    void queryStr
    const res: any = yield call(() => Promise.resolve({ data: [] }))
    yield put(nhanSuActions.layDanhSachXuatNhapThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachXuatNhapThatBai(error))
  }
}

function* fetchDanhSachPhongBan() {
  try {
    const res: ReturnType<typeof duLieuThamChieuApi.layDanhSachPhongBan> = yield call(duLieuThamChieuApi.layDanhSachPhongBan)
    yield put(nhanSuActions.layDanhSachPhongBanThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachPhongBanThatBai(error))
  }
}

function* fetchDanhSachChucVu() {
  try {
    const res: ReturnType<typeof duLieuThamChieuApi.layDanhSachChucDanh> = yield call(duLieuThamChieuApi.layDanhSachChucDanh)
    yield put(nhanSuActions.layDanhSachChucVuThanhCong(res))
  } catch (error) {
    yield put(nhanSuActions.layDanhSachChucVuThatBai(error))
  }
}

export default function* watchNhanSu() {
  yield takeEvery(nhanSuActions.layDanhSachHoSo.toString(), fetchDanhSachHoSo)
  yield takeEvery(nhanSuActions.layDanhSachGiaDinh.toString(), fetchDanhSachGiaDinh)
  yield takeEvery(nhanSuActions.layDanhSachTaiLieu.toString(), fetchDanhSachTaiLieu)
  yield takeEvery(nhanSuActions.layDanhSachHopDong.toString(), fetchDanhSachHopDong)
  yield takeEvery(nhanSuActions.layDanhSachKhenThuongKyLuat.toString(), fetchDanhSachKhenThuongKyLuat)
  yield takeEvery(nhanSuActions.layDanhSachBaoHiem.toString(), fetchDanhSachBaoHiem)
  yield takeEvery(nhanSuActions.layDanhSachDuLieuThamChieu.toString(), fetchDanhSachDuLieuThamChieu)
  yield takeEvery(nhanSuActions.layDanhSachThongTinKhac.toString(), fetchDanhSachThongTinKhac)
  yield takeEvery(nhanSuActions.layDanhSachThaoTacHangLoat.toString(), fetchDanhSachThaoTacHangLoat)
  yield takeEvery(nhanSuActions.layDanhSachXuatNhap.toString(), fetchDanhSachXuatNhap)
  yield takeEvery(nhanSuActions.layDanhSachPhongBan.toString(), fetchDanhSachPhongBan)
  yield takeEvery(nhanSuActions.layDanhSachChucVu.toString(), fetchDanhSachChucVu)
}

